var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.whatsappFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.broadcastMessagePerPrice"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.broadcastPerMessage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "broadcastPerMessage", $$v)
                },
                expression: "featureForm.broadcastPerMessage",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.channelCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.channelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "channelCount", $$v)
                },
                expression: "featureForm.channelCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.businessChannelCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.businessChannelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "businessChannelCount", $$v)
                },
                expression: "featureForm.businessChannelCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.otherFeatures"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.bulkMessageSending,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "bulkMessageSending", $$v)
                  },
                  expression: "featureForm.bulkMessageSending",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.bulkMessageSending")))]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.messageUnregisteredNumbers,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "messageUnregisteredNumbers", $$v)
                  },
                  expression: "featureForm.messageUnregisteredNumbers",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.messageUnregisteredNumbers")))]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.personalizedBroadcastMessage,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.featureForm,
                      "personalizedBroadcastMessage",
                      $$v
                    )
                  },
                  expression: "featureForm.personalizedBroadcastMessage",
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("message.personalizedBroadcastMessage")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.whatsappChatbotEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "whatsappChatbotEntegration", $$v)
                  },
                  expression: "featureForm.whatsappChatbotEntegration",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.chatbotIntegration")))]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.controlWhatsapp,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "controlWhatsapp", $$v)
                  },
                  expression: "featureForm.controlWhatsapp",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.manageWhatsapp")))]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.notAdditionalPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "notAdditionalPrice", $$v)
                  },
                  expression: "featureForm.notAdditionalPrice",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.noAdditionalCost")))]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.whatsappVoiceCalling,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "whatsappVoiceCalling", $$v)
                  },
                  expression: "featureForm.whatsappVoiceCalling",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.whatsappVoiceCalling")))]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }